<template>
  <svg t="1732761976231" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
    :width="size" :height="size">
    <path
      d="M832 896H730.56l-72.576-210.24H361.856L293.44 896H192l270.848-768h98.24L832 896zM629.504 598.976L522.112 279.68c-3.392-10.176-7.04-28.096-11.008-53.504H508.8c-3.392 23.168-7.232 40.96-11.456 53.504l-106.56 319.296h238.72z"
      p-id="2351" data-spm-anchor-id="a313x.search_index.0.i0.20473a81TKPCjl" class="selected" :fill="color" :stroke="stroke || color" :stroke-width="strokeWidth"></path>
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 40
    },
    
    color: {
      type: String,
      default: '#999'
    },
    stroke: {
      type: String,
      default: ''
    },
    strokeWidth: {
      type: Number,
      default: 40
    },
  }
}
</script>

<style
  lang="scss"
  scoped
>
.icon{
  display: inline-block;
}
</style>